import React from 'react'
import SearchIcon from '@mui/icons-material/Search'
import { Box, InputAdornment } from '@mui/material'
import { GridToolbarQuickFilter } from '@mui/x-data-grid'

function CustomSearchbar() {
  return (
    // Added data-cy for cypress test
    <Box
      data-cy='search'
      sx={{ display: 'flex', alignItems: 'center', minWidth: '200px' }}
    >
      <GridToolbarQuickFilter
        sx={{
          paddingBottom: '0px'
        }}
        debounceMs={250}
        InputProps={{
          sx: {
            background: 'white',
            borderRadius: '8px',
            '.MuiInput-input': {
              marginRight: '8px'
            },
            height: '40px',
            // copied shadow + border from Google searchbar
            boxShadow: '0 1px 6px rgb(32 33 36 / 5%)',
            border: '1px solid #dfe1e5'
          },
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon
                fontSize='small'
                sx={{
                  paddingLeft: '10px'
                }}
              />
            </InputAdornment>
          ),
          disableUnderline: true
        }}
      />
    </Box>
  )
}

CustomSearchbar.propTypes = {}

export default CustomSearchbar
